export default {
  meta: {
    title: '竞品监测看板',
    url: '/monitoring/competitor' // 埋点用，记录所属模块
  },
};
